import React from 'react';
import {
  Dialog,
  DialogContent,
  makeStyles,
  createStyles,
  Theme,
  useTheme,
  useMediaQuery,
} from '@material-ui/core';
import clsx from 'clsx';
import { BottomTransition, ModalWidthValues } from '../helpers';
import { dimensions } from '../../../theme';

type DynamicModalProps = {
  children?: React.ReactNode;
  isOpen: boolean;
  onBackdropClick?: () => void;
  mobileDrawer?: boolean;
  maxWidth?: ModalWidthValues;
  minHeight?: number;
  className?: string;
};

type MobileDrawerType = {
  mobileDrawer: boolean;
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    dialogContent: ({ mobileDrawer }: MobileDrawerType) => ({
      borderRadius: 10,
      [theme.breakpoints.down('sm')]: {
        borderRadius: mobileDrawer ? '10px 10px 0 0' : 10,
        marginTop: mobileDrawer ? dimensions.bottomDrawerTopSpace : 0,
        maxHeight: `calc(100% - ${dimensions.bottomDrawerTopSpace}px)`,
      },
    }),
    backdrop: {
      background: 'rgba(0, 0, 0, 0.5)',
    },
  }),
);

const DynamicModal = ({
  children,
  isOpen,
  onBackdropClick,
  mobileDrawer = false,
  maxWidth = 'lg',
  minHeight = 0,
  className = '',
}: DynamicModalProps): JSX.Element => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const classes = useStyles({ mobileDrawer });

  function stopPropagation(e: React.MouseEvent): void {
    e.stopPropagation();
  }

  return (
    <Dialog
      data-testid="dialog-root"
      open={isOpen}
      onClick={onBackdropClick}
      TransitionComponent={BottomTransition}
      PaperProps={{
        className: clsx(classes.dialogContent, className),
        style: {
          minHeight,
        },
      }}
      BackdropProps={{
        className: classes.backdrop,
      }}
      fullScreen={isMobile && mobileDrawer}
      maxWidth={maxWidth}
      fullWidth
    >
      <DialogContent data-testid="dialog-content" onClick={stopPropagation}>
        {children}
      </DialogContent>
    </Dialog>
  );
};

export default DynamicModal;
